module.exports = __webpack_public_path__ + "static/media/analytics.34140c28.png";